import { useLoggedIn } from '@immediate_media/auth-lib-react';
import { useState, useEffect } from 'react';
import useFabricApi from './use-fabric-api';

// TODO: Probably pull this out to be called once from somewhere at the root
// level and passed in via the context API, similar to the SettingsContext
const useUserProfile = () => {
  const [claims, setClaims] = useState();
  const fabricApi = useFabricApi();
  const isLoggedIn = useLoggedIn();
  useEffect(() => {
    const fetchClaims = async () => {
      let unformattedClaims;
      try {
        unformattedClaims = await fabricApi.userAccounts.claims.filter();
      } catch (err) {
        // The access and refresh tokens have probably expired
        if (err.response?.status === 401) {
          setClaims();
          return;
        }
        throw err;
      }
      const formattedClaims = unformattedClaims.reduce((accumulator, setting) => {
        const obj = accumulator;
        try {
          // Account for any JSON stringified values, such as the user avatar
          obj[setting.type] = JSON.parse(setting.value);
        } catch (e) {
          obj[setting.type] = setting.value;
        }
        return obj;
      }, {});
      setClaims(formattedClaims);
    };
    if (isLoggedIn) {
      fetchClaims();
      return;
    }
    setClaims();
  }, [fabricApi.userAccounts.claims, isLoggedIn]);
  return claims;
};
export default useUserProfile;